const BASE = "https://app.magic-comment.com/avatars/";
export const AGENT_FALLBACK_AVATAR =
  "https://app.magic-comment.com/agents/ai-agent.svg";

export const MC_AVATARS = [
  { id: "blue", label: "Blue avatar", url: `${BASE}avatar-blue.png` },
  { id: "brand", label: "Brand avatar", url: `${BASE}avatar-brand.png` },
  { id: "green", label: "Green avatar", url: `${BASE}avatar-green.png` },
  { id: "pink", label: "Pink avatar", url: `${BASE}avatar-pink.png` },
  { id: "purple", label: "Purple avatar", url: `${BASE}avatar-purple.png` },
  { id: "yellow", label: "Yellow avatar", url: `${BASE}avatar-yellow.png` },
] as const;

const MC_AVATAR_URLS = new Set<string>(MC_AVATARS.map((avatar) => avatar.url));

export function isMcAvatarUrl(value: string | undefined): value is string {
  return Boolean(value && MC_AVATAR_URLS.has(value));
}

export function randomMcAvatarUrl(): string {
  return MC_AVATARS[Math.floor(Math.random() * MC_AVATARS.length)]!.url;
}

/**
 * Deterministically map a person's name to one of the six hosted avatar PNGs
 * using a djb2 hash. Same (case-insensitive, trimmed) name always resolves to
 * the same URL. Shared contract with the dashboard — keep BASE/FILES/hash in
 * sync across both.
 */
export function avatarForName(name: string): string {
  const key = (name ?? "").trim().toLowerCase();
  if (key === "agent") {
    return AGENT_FALLBACK_AVATAR;
  }
  let h = 5381;
  for (let i = 0; i < key.length; i++) {
    h = ((h * 33) ^ key.charCodeAt(i)) >>> 0;
  }
  return MC_AVATARS[h % MC_AVATARS.length]!.url;
}
